import { render, staticRenderFns } from "./AccountCreationWizardPage.vue?vue&type=template&id=5901f0a4"
import script from "./AccountCreationWizardPage.vue?vue&type=script&lang=ts"
export * from "./AccountCreationWizardPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports